module.exports = __webpack_public_path__ + "static/media/kybsubmitted.df42d973.svg";